export default __webpack_public_path__ + "static/media/galaxia.19bcdb4e.png";